module.exports = __webpack_public_path__ + "static/img/record.5dff8cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/record.png
// module id = bj4f
// module chunks = 12